export class Constants {
    static calculators = {
        individual: 'individual',
        business: 'business',
        events: 'events'
    };
    static categories = {
        individual: {
            vehicle: 'vehicle',
            transit: 'transit',
            travel: 'airTravel',
            home: 'home',
        },
        business: {
            site: 'site',
            fleet: 'fleet',
            travel: 'travel',
            commute: 'commute',
            shipping: 'shipping',
            server: 'server',
        },
        events: {
            travel: 'travel',
            hotel: 'hotel',
            commute: 'commute',
            venue: 'venue',
            water: 'water',
            meals: 'meals',
        },
    };
    static headerTitles = {
        individual: {
            vehicle: 'Vehicle',
            transit: 'Public Transit',
            travel: 'Air Travel',
            home: 'Home Energy',
        },
        business: {
            gate: 'calculator',
            site: 'Site',
            fleet: 'Fleet',
            travel: 'Air Travel',
            commute: 'Commute',
            shipping: 'Shipping',
            server: 'Server',
        },
        events: {
            gate: 'calculator',
            travel: 'travel',
            commute: 'commute',
            venue: 'venue',
            water: 'water',
            meals: 'meals',
        },
    };
    static limitPerOneEmailPerDay = 10; // Max count of sent e-mails per day per one e-mail
}



// WEBPACK FOOTER //
// ./src/app/config/constants.ts